import { __assign } from "tslib";
export var EmissionFactorInclude = {
    locations: { where: { deleted: false } },
    products: { where: { deleted: false } },
    businessUnits: { where: { deleted: false } },
    territory: { include: { continent: true } },
    modeledImpact: true,
    denominatorUnit: true,
    supplier: true,
    activityDataSource: {
        include: {
            activityDataSourceTypes: true,
        },
    },
    unit: true,
    origin: true,
    children: {
        include: {
            unit: true,
            activityDataSource: true,
        },
    },
};
/**
 * A lightweight include that should be used for lists of factors.
 */
export var EmissionFactorIncludeFilteredForList = function () { return ({
    territory: { include: { continent: true } },
    activityDataSource: {
        include: {
            parent: true,
            activityDataSourceTypes: true,
        },
    },
    supplier: true,
    children: {
        include: {
            unit: true,
        },
    },
    unit: true,
    origin: true,
    modeledImpact: true,
}); };
export var EmissionFactorIncludeFiltered = function (organizationId) { return (__assign(__assign({}, EmissionFactorIncludeFilteredForList()), { locations: { where: { deleted: false } }, products: { where: { deleted: false } }, businessUnits: { where: { deleted: false } }, modeledImpact: true, denominatorUnit: true, unit: true, origin: true, children: {
        where: {
            OR: [{ organizationId: organizationId }, { organizationId: null }],
        },
        include: {
            unit: true,
            activityDataSource: true,
        },
    } })); };
//# sourceMappingURL=EmissionFactor.js.map